// Yeshiva University's undergraduate majors (#2748). Read on 2026-10-01
// from YU Undergraduate Admissions' Academic Programs and Majors page
// (apply.yu.edu/academics), which lists the majors of Yeshiva College,
// Stern College for Women and the Sy Syms School of Business. Left out: the
// three Honors programs (tracks, not majors) and the Katz School's
// associate degree programs (Liberal Arts, Management). The page names no
// degree types, so `degree` is null. Names are as the page writes them,
// including "Shaped Major" and the dash in the Jewish Studies tracks.
// The KB's majors list was the starting point; the school's page wins.
const majors = {
    "slug": "yeshiva-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major on YU's official Academic Programs and Majors page, grouped by the college that offers it. The page does not name degree types. Honors programs, the associate degree programs, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Yeshiva College",
            "source": {
                "label": "YU Undergraduate Admissions, Academic Programs and Majors",
                "url": "https://apply.yu.edu/academics"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Shaped Major",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                }
            ]
        },
        {
            "name": "Stern College for Women",
            "source": {
                "label": "YU Undergraduate Admissions, Academic Programs and Majors",
                "url": "https://apply.yu.edu/academics"
            },
            "majors": [
                {
                    "name": "Art History (Shaped Major)",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Childhood Education",
                    "degree": null
                },
                {
                    "name": "Early Childhood Education",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Jewish Studies - Bible",
                    "degree": null
                },
                {
                    "name": "Jewish Studies - Jewish History",
                    "degree": null
                },
                {
                    "name": "Jewish Studies - Jewish Philosophy",
                    "degree": null
                },
                {
                    "name": "Jewish Studies - Judaic Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physical Sciences",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Studio Art (Shaped Major)",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Speech Pathology & Audiology",
                    "degree": null
                }
            ]
        },
        {
            "name": "Sy Syms School of Business",
            "source": {
                "label": "YU Undergraduate Admissions, Academic Programs and Majors",
                "url": "https://apply.yu.edu/academics"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Business Analytics",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Strategy & Entrepreneurship",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
